import { Component, EventEmitter, OnDestroy, OnInit, Output, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import moment from "app/util/dayjs";
import { ControlHorarioService } from "../../services/control-horario/control-horario.service";

import { UserService } from "app/services/user/user.service";
import { ProfileUser } from "app/shared/models/user.interface";
import { TiposEntradaComponent } from "../tipos-entrada/tipos-entrada.component";

@Component({
    selector: "app-time-control",
    templateUrl: "./time-control.component.html",
    styleUrls: ["./time-control.component.scss"],
    standalone: false
})
export class TimeControlComponent implements OnInit, OnDestroy {
    @Output() reload = new EventEmitter();

    readonly tiempoTrabajado = signal(0);
    currentDate: number;
    tiposEntradas: Array<any>;
    estados: any;
    tipoEntradaSelected: any;
    readonly estadoActual = signal(2);
    firstEntry: number;
    lastPause: number;
    regEdit: any;
    newHour: any;
    person: any;
    nuevoHorario: any = null;
    readonly jornada_concluida = signal(false);

    private ultimaEntrada: number;
    private tiempoTrabajoInicio: number;
    private timepoTranscurrido: number;
    private intervalCountTime: any;

    constructor(
        private controlSvc: ControlHorarioService,
        public dialog: MatDialog,
        private snackBar: MatSnackBar,
        private userSvc: UserService
    ) {
        this.initData();
    }

    ngOnInit(): void {
        this.loadTiposEntradas();
        this.getStatusUser();
        this.userSvc.profile().subscribe((data: ProfileUser) => {
            this.person = data.persona;
            this.controlSvc.checkJornadaCompletada(this.person.id).subscribe((data) => {
                this.jornada_concluida.set(!!data);
            });
        });

        this.controlSvc.onReloadTimeControl.subscribe(() => {
            this.stopCountTime();
            this.initData();
            this.loadTiposEntradas();
            this.getStatusUser();
        });

        this.controlSvc.onDestroyTimeControl.subscribe(() => {
            this.stopCountTime();
        });
    }

    ngOnDestroy(): void {
        this.stopCountTime();
    }

    initData() {
        this.currentDate = Date.now();
        this.tiempoTrabajado.set(0);
        this.tiempoTrabajoInicio = 0;
        this.timepoTranscurrido = 0;

        this.estados = {
            AUTOCIERRE: 3,
            SALIDA: 2,
            TRABAJANDO: 0,
            EN_PAUSA: 1
        };

        this.tiposEntradas = [];
        this.estadoActual.set(2);
    }

    loadTiposEntradas() {
        this.controlSvc.getTiposEntradas().subscribe(
            (data) => {
                this.tiposEntradas = data;
            },
            (err) => {
                console.log(err);
            }
        );
    }

    getStatusUser() {
        this.controlSvc.getUserState().subscribe(
            (data) => {
                this.tipoEntradaSelected = data.entryType;
                this.estadoActual.set(data.breakType);
                this.tiempoTrabajoInicio = data.workTimeTotal;
                this.ultimaEntrada = data.lastEntry;
                this.firstEntry = data.firstEntry;
                this.lastPause = data.lastPause;
                this.regEdit = data.regEdit;

                this.getTiempoTrabajado();
                if (this.estados && this.estadoActual() === this.estados.TRABAJANDO && this.ultimaEntrada !== null) {
                    this.startCountTime();
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    momentTiempoTrabajado() {
        let formatTiempoTrabajado = "00:00:00";
        const worked = this.tiempoTrabajado();
        if (worked !== 0) {
            formatTiempoTrabajado = moment.utc(worked).format("HH:mm:ss");
        }
        return formatTiempoTrabajado;
    }

    momentHora(timer) {
        return moment(timer).format("HH:mm");
    }

    getTiempoTrabajado() {
        this.tiempoTrabajado.set(this.tiempoTrabajoInicio + this.timepoTranscurrido);
    }

    private startCountTime() {
        this.timepoTranscurrido = 0;
        this.intervalCountTime = setInterval(() => {
            this.calculateWorkTime();
        }, 1000);
    }

    private stopCountTime() {
        this.timepoTranscurrido = 0;
        clearInterval(this.intervalCountTime);
    }

    private calculateWorkTime() {
        const now = moment();
        const momentLastDate = moment(this.ultimaEntrada);
        this.timepoTranscurrido = now.diff(momentLastDate);
        this.getTiempoTrabajado();
    }

    openModalTiposEntradas() {
        if (this.tiposEntradas.length > 0) {
            const dialogRef = this.dialog.open(TiposEntradaComponent, {
                panelClass: [],
                width: "50vw",
                disableClose: false,
                autoFocus: false,
                data: { tiposEntradas: this.tiposEntradas }
            });

            dialogRef.beforeClosed().subscribe((response) => {
                if (response) {
                    this.tipoEntradaSelected = response;
                    this.changeStatus("play");
                }
            });
        }
    }

    changeStatus(status) {
        // TODO: Si esta activado la geoposicion obtener la posicion del usuario
        const positionUser = {
            latitude: 0,
            longitude: 0,
            accuracy: 0,
            errorGps: ""
        };

        switch (status) {
            case "play":
                this.startTelework(positionUser);
                break;
            case "pause":
                this.stopTelework(this.estados.EN_PAUSA, positionUser);
                break;
            case "continue":
                this.startTelework(positionUser);
                break;
            case "stop":
                this.stopTelework(this.estados.SALIDA, positionUser);
                this.reload.emit();
                break;

            default:
                break;
        }
    }

    openModaEditarRegistro(templateRef) {
        const dialogRef2 = this.dialog.open(templateRef, {
            width: "300px"
        });

        dialogRef2.beforeClosed().subscribe((response) => {
            if (response) {
                this.editarRegistro(this.regEdit, response);
            }

            this.nuevoHorario = null;
        });
    }

    startTelework(positionUser) {
        //this.loadingService.presentLoading("Guardando registro...");
        this.controlSvc.startTelework(this.tipoEntradaSelected.id, positionUser).subscribe(
            (data) => {
                //this.loadingService.hideLoading();
                this.getStatusUser();
            },
            (err) => {
                //this.loadingService.hideLoading();
                console.log(err);
            }
        );
    }

    stopTelework(estado, positionUser) {
        //this.loadingService.presentLoading("Guardando registro...");
        this.controlSvc.stopTelework(estado, positionUser).subscribe(
            (data) => {
                //this.loadingService.hideLoading();
                this.stopCountTime();
                this.getStatusUser();
            },
            (err) => {
                //this.loadingService.hideLoading();
                console.log(err);
            }
        );
    }

    editarRegistro(registro, newHour) {
        const dataUpdate = {
            id: registro.id,
            entryTime: registro.exit === 0 ? newHour : null,
            exitTime: registro.exit === 1 ? newHour : null
        };

        //this.loadingService.presentLoading("Editando el registro...");
        this.controlSvc.updateTelework(dataUpdate).subscribe(
            (data) => {
                //this.loadingService.hideLoading();
                this.stopCountTime();
                this.getStatusUser();
            },
            (err) => {
                //this.loadingService.hideLoading();
                this.snackBar.open(err, "X", {
                    duration: 3000
                });
            }
        );
    }
}
